/**
 * Class decorator factory that defines the decorated class as a custom element. Based on @lit/reactive-element/development/decorators/custom-element.js and prevents duplicate custom element definitions.
 *
 * ```js
 * @customElement('my-element')
 * class MyElement extends LitElement {
 *   render() {
 *     return html``;
 *   }
 * }
 * ```
 * @category Decorator
 * @param tagName The tag name of the custom element to define.
 */
export const customElement =
  (tagName: string) => (classOrTarget: CustomElementConstructor, context?: ClassDecoratorContext) => {
    if (context !== undefined) {
      context.addInitializer(() => {
        if (!customElements.get(tagName)) customElements.define(tagName, classOrTarget);
      });
    } else {
      if (!customElements.get(tagName)) customElements.define(tagName, classOrTarget);
    }
  };
